// import decodeJwt from "jwt-decode";
import { DEFAULT_API_CONFIG } from './apiConfig';

const { url, getHeaders } = DEFAULT_API_CONFIG;
const baseRoute = `${url}/FileImport`;

export const getFileImportHistory = async () => {
  const url = `${baseRoute}/history`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  return response.ok ? await response.json() : Promise.reject(response);
};

export const submitFile = async file => {
  const url = `${baseRoute}/file`;
  let headers = getHeaders();
  delete headers['Content-Type'];

  const formData = new FormData();
  formData.append('file', file);

  const response = await fetch(url, {
    method: 'POST',
    body: formData,
    headers,
  });

  return response.ok ? response : Promise.reject(response);
};

export const createFileImportOrder = async (fileImport, id, overrideAddress) => {
  const url = `${baseRoute}/orders?overrideAddress=${!!overrideAddress}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(fileImport),
    headers,
  });
  return response.ok ? await response.json() : Promise.reject(response);
};

export const getFileImportRushTypes = async () => {
  const url = `${baseRoute}/RushTypes`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  return response.ok ? await response.json() : Promise.reject(response);
};

export const getFileImportProntoStructureTypes = async () => {
  const url = `${baseRoute}/ProntoStructureTypes`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  return response.ok ? await response.json() : Promise.reject(response);
};

export const createChildOrder = async body => {
  const url = `${baseRoute}/CreateChildOrder`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(body),
    headers,
  });
  return response.ok ? await response.json() : Promise.reject(response);
};
